import { css } from '@emotion/react';
var TypographyHeadlineSize;

(function (TypographyHeadlineSize) {
  TypographyHeadlineSize["Headline"] = "Headline";
  TypographyHeadlineSize["Heading1"] = "Heading1";
})(TypographyHeadlineSize || (TypographyHeadlineSize = {}));

var TypographySize;

(function (TypographySize) {
  TypographySize["Heading2"] = "Heading2";
  TypographySize["Heading3"] = "Heading3";
  TypographySize["Heading4"] = "Heading4";
  TypographySize["Body1"] = "Body1";
  TypographySize["Body2"] = "Body2";
  TypographySize["Label1"] = "Label1";
  TypographySize["Label2"] = "Label2";
})(TypographySize || (TypographySize = {}));

var TypographyHeadlineDesktop = {
  Headline: {
    fontSize: '54px',
    lineHeight: '64px',
    letterSpacing: '-0.01em',
    fontWeight: 700
  },
  Heading1: {
    fontSize: '36px',
    lineHeight: '48px',
    letterSpacing: '-0.01em',
    fontWeight: 600
  }
};
var TypographyHeadlineMobile = {
  Headline: {
    fontSize: '44px',
    lineHeight: '52px',
    fontWeight: 700,
    letterSpacing: '-0.01em'
  },
  Heading1: {
    fontSize: '32px',
    lineHeight: '40px',
    fontWeight: 600,
    letterSpacing: '-0.01em'
  }
};
var Typography = {
  Heading2: {
    fontSize: '24px',
    lineHeight: '32px',
    fontWeight: 400
  },
  Heading3: {
    fontSize: '20px',
    lineHeight: '24px',
    fontWeight: 600
  },
  Heading4: {
    fontSize: '16px',
    lineHeight: '24px',
    fontWeight: 600
  },
  Body1: {
    fontSize: '16px',
    lineHeight: '24px',
    fontWeight: 400
  },
  Body2: {
    fontSize: '14px',
    lineHeight: '20px',
    fontWeight: 400
  },
  Label1: {
    fontSize: '16px',
    lineHeight: '24px',
    fontWeight: 600
  },
  Label2: {
    fontSize: '14px',
    lineHeight: '20px',
    fontWeight: 600
  }
};
var desktopTypographyStyles = /*#__PURE__*/css("h1{", TypographyHeadlineDesktop.Heading1, ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:desktopTypographyStyles;"));
var mobileTypographyStyles = /*#__PURE__*/css("h1{", TypographyHeadlineMobile.Heading1, ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:mobileTypographyStyles;"));
var commonTypographyStyles = /*#__PURE__*/css("h2{", Typography.Heading2, ";}h3{", Typography.Heading3, ";}h4{", Typography.Heading4, ";}body,p{", Typography.Body1, ";}small{", Typography.Body2, ";}label{", Typography.Label1, ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:commonTypographyStyles;"));
export { Typography, TypographyHeadlineDesktop, TypographyHeadlineMobile, TypographyHeadlineSize, TypographySize, commonTypographyStyles, desktopTypographyStyles, mobileTypographyStyles };
